import { currencyFormatterAUD } from "../../utils";

export function moneyFormatter(params) {
    return currencyFormatterAUD(params.value);
};

export function percentFormatter(params) {
    return `${params.value}%`;
};
